// extracted by mini-css-extract-plugin
export default {"container":"review_container__VEN3b","reviewcontainer":"review_reviewcontainer__BlWvh","img":"review_img__TdD0j","el1":"review_el1__QRL8-","el2":"review_el2__4kUXL"};